import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 *传感器设备图层
 */
export default class DeviceLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.DEVICE;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude&&item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    name: item.tagId,
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("../../img/map/device.png"),
                        show : true,
                        width : 52,
                        height : 64,
                        pixelOffset:new Cesium.Cartesian2(-10, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
}
